export default {
  title: "{{collectionEntityLabelPlural}}",
  description: "Explore guided {{collectionEntityLabelPluralLower}} to master new skills",
  myRoadmaps: "My {{collectionEntityLabelPlural}}",
  myRoadmapsDescription: "Track your learning progress across {{collectionEntityLabelPluralLower}}",
  noRoadmapsYet: "You haven't enrolled in any {{collectionEntityLabelPluralLower}} yet",
  noRoadmaps: "No {{collectionEntityLabelPluralLower}} available",
  browseRoadmaps: "Browse available {{collectionEntityLabelPluralLower}} to get started",
  enroll: "Enroll",
  enrolled: "Enrolled",
  progress: "Progress",
  completed: "Completed",
  inProgress: "In Progress",
  listView: "List",
  weekView: "Week",

  // Pace configuration
  configurePace: "Set Your Pace",
  configurePaceDescription: "Choose how much time you want to dedicate to \"{{title}}\" each week",
  weeklyMinutes: "Weekly study time",
  sessionsPerWeek: "Sessions per week",
  week: "week",
  paceSummary: "~{{minutes}} minutes per session, {{sessions}} times per week",

  // Weekly plan
  weeklyPlan: "Weekly Plan",
  weeklyPlanSummary: "{{minutes}} minutes across {{sessions}} sessions this week",
  noWeeklyPlan: "Enroll to see your weekly study plan",
  noSessionPlanned: "Rest day",
  currentlyStudying: "Currently studying",
  upNext: "Up next",

  // Next up
  nextUp: "Continue",
  nextUpNotStarted: "Ready to start",
  nextUpInProgress: "Pick up where you left off",
  nextUpNextInSequence: "Next in sequence",

  // Course actions
  startCourse: "Start",
  continue: "Continue",
  review: "Review",
}
